/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';

import * as S from './styled/Skeleton.styled';

/**
 * @author Burak Unsal
 */

const Skeleton = (props) => {
	const { size, borderRadius, width, height, circle, css, className, ...moreProps } = props;

	return (
		<S.Skeleton
			className={`skeleton ${className ?? ''} ${circle ? 'circle' : ''}`}
			size={size}
			borderRadius={borderRadius}
			width={width}
			height={height}
			css={css}
			color={props.color}
			{...moreProps}
		/>
	);
};

Skeleton.propTypes = {
	/** Size of the element, options are "small", "medium", "large". */
	size: PropTypes.string,
	/** Border radius of the element. */
	borderRadius: PropTypes.string,
	/** Width of the element. */
	width: PropTypes.string,
	/** Height of the element. */
	height: PropTypes.string,
	/** If true, a circle will be rendered. */
	circle: PropTypes.bool,
	/** Custom CSS styles. */
	css: PropTypes.object,
	/** Custom class name. */
	className: PropTypes.string,
	/** Color of the element. */
	color: PropTypes.string
};
export default Skeleton;
